import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=3bbfbfa5&scoped=true&"
import script from "./SplashScreen.vue?vue&type=script&lang=js&"
export * from "./SplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=3bbfbfa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfbfa5",
  null
  
)

export default component.exports